import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import {extractIconProps, extractProps} from 'utils/propUtils';


const propTypes = {
  // iconProps
  className: PropTypes.string,
  size: PropTypes.string,
  transform: PropTypes.string,
};

export default function WarningIcon(props) {
  return <FontAwesomeIcon icon={['far', 'triangle-exclamation']} {...extractIconProps(props)} {...extractProps(props)} />;
}
WarningIcon.propTypes = propTypes;
